// extracted by mini-css-extract-plugin
module.exports = {"root":"LanguagePicker_root__33pFp","picker":"LanguagePicker_picker__2o9c0"};